import AddressTypes from 'constants/addressTypes';
export default function getRegistryAddressPrefill(userData, isNewCustomer, addressType) {
  const isEligibleForRegistryPrefill = isNewCustomer && addressType !== AddressTypes.SHIPPING;
  if (!isEligibleForRegistryPrefill || !userData) {
    return {
      shouldPrefillFromRegistry: false,
      shouldShowMissingRegistryAddressInfo: false,
      addressLine1: '',
      postalCode: '',
      postalDistrict: ''
    };
  }
  const hasAddressLine = Boolean(userData.address || userData.houseNumber);
  const hasCompleteAddress = Boolean(hasAddressLine && userData.areaCode);
  if (!hasCompleteAddress) {
    return {
      shouldPrefillFromRegistry: isEligibleForRegistryPrefill,
      shouldShowMissingRegistryAddressInfo: true,
      addressLine1: '',
      postalCode: '',
      postalDistrict: ''
    };
  }
  return {
    shouldPrefillFromRegistry: isEligibleForRegistryPrefill,
    shouldShowMissingRegistryAddressInfo: false,
    addressLine1: [userData.address, userData.houseNumber].filter(Boolean).join(' '),
    postalCode: userData.areaCode || '',
    postalDistrict: userData.area || ''
  };
}